import { on as r, off as o } from "./ghl-ui.es710.js";
const d = "@@coContext", u = {
  mounted(t, { value: c, modifiers: e }) {
    t[d] = {
      handler: void 0
    }, typeof c == "function" && (t[d].handler = c, r("clickoutside", t, c, {
      capture: e.capture
    }));
  },
  updated(t, { value: c, modifiers: e }) {
    const n = t[d];
    typeof c == "function" ? n.handler ? n.handler !== c && (o("clickoutside", t, n.handler, {
      capture: e.capture
    }), n.handler = c, r("clickoutside", t, c, {
      capture: e.capture
    })) : (t[d].handler = c, r("clickoutside", t, c, {
      capture: e.capture
    })) : n.handler && (o("clickoutside", t, n.handler, {
      capture: e.capture
    }), n.handler = void 0);
  },
  unmounted(t, { modifiers: c }) {
    const { handler: e } = t[d];
    e && o("clickoutside", t, e, {
      capture: c.capture
    }), t[d].handler = void 0;
  }
}, a = u;
export {
  a as default
};
